module.exports = __webpack_public_path__ + "static/media/share-icon-close.679f3f2c.svg";